import {GlobalPosterEditorJqueryElement} from '@Components/poster-editor/poster-editor.types';
import {ZOOM_MAX} from '@PosterWhiteboard/poster/poster-scaling.class';

export const EDITOR_LEFT_MARGIN = 120;
export const EDITOR_RIGHT_MARGIN = 342;
export const EDITOR_RIGHT_MARGIN_SMALL = 50;
export const EDITOR_BOTTOM_BAR_BOTTOM_OFFSET = 12;
export const EDITOR_DEFAULT_SCROLL_GAP = 20;

export function handleScrollingOnWhiteboard(deltaX: number, deltaY: number): void {
  const whiteboardContainer = window.posterEditor?.elements[GlobalPosterEditorJqueryElement.WHITEBOARD_CONTAINER]?.get(0);
  if (!whiteboardContainer) return;

  const horizontalScrollValue = whiteboardContainer.scrollLeft + deltaX;
  const verticalScrollValue = whiteboardContainer.scrollTop + deltaY;
  whiteboardContainer.scroll({
    left: horizontalScrollValue,
    top: verticalScrollValue,
    behavior: 'instant',
  });

  window.posterEditor?.whiteboard?.refreshAllVisibleCanvases();
}

export function adjustScrollForZoom(e: WheelEvent, prevScale: number, newScale: number): void {
  if (prevScale === newScale) return;
  const whiteboardContainer = document.getElementById('poster-whiteboard-container');
  if (!whiteboardContainer) return;

  const backdrop = whiteboardContainer.querySelector('.pmw-page-container') as HTMLElement;
  const scale = window.posterEditor?.whiteboard?.scaling.scale;
  if (!scale) return;
  if (!backdrop) return;

  const rect = whiteboardContainer.getBoundingClientRect();
  const mouseX = e.clientX - rect.left - EDITOR_LEFT_MARGIN;
  const mouseY = e.clientY - rect.top;

  const scrollLeft = whiteboardContainer.scrollLeft;
  const scrollTop = whiteboardContainer.scrollTop;

  const newScrollLeft = (scrollLeft + mouseX) * (newScale / prevScale) - mouseX;
  const newScrollTop = (scrollTop + mouseY) * (newScale / prevScale) - mouseY;

  whiteboardContainer.scroll({
    left: newScrollLeft,
    top: newScrollTop,
    behavior: 'instant',
  });
}

export function zoomOnWheel(e: WheelEvent): void {
  const whiteboardContainer = document.getElementById('poster-whiteboard-container');
  if (!whiteboardContainer) return;

  const backdrop = whiteboardContainer.querySelector('.pmw-page-container') as HTMLElement;
  const scale = window.posterEditor?.whiteboard?.scaling.scale;
  if (!scale) return;
  if (!backdrop) return;

  const zoomIntensity = 0.02;
  const rect = backdrop.getBoundingClientRect();

  const mouseX = e.clientX;
  const mouseY = e.clientY;
  const offsetX = mouseX - rect.left;
  const offsetY = mouseY - rect.top;

  const scrollLeft = whiteboardContainer.scrollLeft;
  const scrollTop = whiteboardContainer.scrollTop;

  const scaleFactor = e.deltaY < 0 ? 1 + zoomIntensity : 1 - zoomIntensity;
  const newScale = Math.max(0.1, scale * scaleFactor);

  if (newScale < 1) {
    backdrop.style.transformOrigin = 'unset';
  } else {
    backdrop.style.transformOrigin = '0 0';
  }
  backdrop.style.transform = `scale(${newScale})`;

  // Adjust scroll so it zooms centered on the cursor
  whiteboardContainer.scrollLeft = offsetX * scaleFactor - offsetX + scrollLeft;
  whiteboardContainer.scrollTop = offsetY * scaleFactor - offsetY + scrollTop;
}
